export default __webpack_public_path__ + "static/FilsonSoft-Bold-a0c7f19a74631845f69533ccfec9964b.ttf";